import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh',
  textAlign: 'center',
  fontFamily: 'Arial, sans-serif',
  color: '#333',
};

const headingStyle: React.CSSProperties = {
  fontSize: '2.5rem',
  marginBottom: '1rem',
};

const iconStyle: React.CSSProperties = {
  fontSize: '4rem',
  marginBottom: '1.5rem',
  color: '#555',
};

const buttonStyle: React.CSSProperties = {
  marginTop: '2rem',
  padding: '12px 24px',
  fontSize: '1rem',
  color: 'white',
  backgroundColor: '#000080', // Azul marinho (Navy)
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out',
};

const NaoAutorizado = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navega para a entrada anterior no histórico de navegação
  };

  return (
    <div style={containerStyle}>
      <LockOutlinedIcon style={iconStyle} />
      <h1 style={headingStyle}>Acesso Não Autorizado</h1>
      <p>Você não tem as permissões necessárias para visualizar esta página.</p>
      <button style={buttonStyle} onClick={handleGoBack}>
        Voltar para a Página Anterior
      </button>
    </div>
  );
};

export default NaoAutorizado;